import { PhoneBankingApplication } from "@/modules/application/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const PhoneBankingApplicationPage = ({ isEdit, isCopy }: IOperationPageProps) => (
  <PhoneBankingApplication isEdit={isEdit} isCopy={isCopy}/>
);
